import { createApp } from 'vue';

import { initSentry } from '@/javascripts/utils/sentry_helper';

// Vueの初期化
import SlideFormLicenseCheck from '@/javascripts/components/slide_form_license_check.vue';

async function initialize() {
    const app = createApp(SlideFormLicenseCheck);
    initSentry(app);
    app.mount('#app');
}

initialize();
